import React from 'react';
import { Box } from '@chakra-ui/react';

import { useScannedRelevosContext } from '../../contexts/ScannedRelevosContext';
import { useRestaurantsData } from '../../services/restaurants';
import { QuickContactsReturnItems } from './components/QuickContactsReturnItemsList/QuickContactsReturnItems';
import { ScanReturn } from './components/ScanReturn/ScanReturn';
import { SelectAssignmentMode } from './components/SelectAssignmentMode/SelectAssignmentMode';
import { ItemAssignmentScannersModes } from './components/UserSelect/types';

export const Return = () => {
  const { selectItemMode } = useScannedRelevosContext();
  const { isQuickContactsEnabled } = useRestaurantsData();
  return (
    <>
      <Box p={2}>
        <Box width={'100%'} py={4}>
          <SelectAssignmentMode />
        </Box>
      </Box>
      {ItemAssignmentScannersModes.includes(selectItemMode) || !isQuickContactsEnabled ? (
        <ScanReturn />
      ) : (
        <QuickContactsReturnItems />
      )}
    </>
  );
};
